export var badgePortalTokens = {
  paddingX: "0.25em",
  paddingY: "0.6em",
  borderRadius: "1em",
  variants: {
    red: {
      text: function text(_ref) {
        var color = _ref.color;
        return color.text.black.base;
      },
      bg: function bg(_ref2) {
        var palette = _ref2.palette;
        return palette.newRed.hex5;
      }
    },
    orange: {
      text: function text(_ref3) {
        var color = _ref3.color;
        return color.text.black.base;
      },
      bg: function bg(_ref4) {
        var palette = _ref4.palette;
        return palette.newOrange.hex5;
      }
    },
    orangeLight: {
      text: function text(_ref5) {
        var color = _ref5.color;
        return color.text.black.base;
      },
      bg: function bg(_ref6) {
        var palette = _ref6.palette;
        return palette.newOrangeLight.hex5;
      }
    },
    blue: {
      text: function text(_ref7) {
        var color = _ref7.color;
        return color.text.black.base;
      },
      bg: function bg(_ref8) {
        var palette = _ref8.palette;
        return palette.newBlue.hex5;
      }
    },
    blueLight: {
      text: function text(_ref9) {
        var color = _ref9.color;
        return color.text.black.base;
      },
      bg: function bg(_ref10) {
        var palette = _ref10.palette;
        return palette.newBlueLight.hex5;
      }
    },
    green: {
      text: function text(_ref11) {
        var color = _ref11.color;
        return color.text.black.base;
      },
      bg: function bg(_ref12) {
        var palette = _ref12.palette;
        return palette.newGreen.hex5;
      }
    },
    violet: {
      text: function text(_ref13) {
        var color = _ref13.color;
        return color.text.black.base;
      },
      bg: function bg(_ref14) {
        var palette = _ref14.palette;
        return palette.newViolet.hex5;
      }
    },
    base: {
      text: function text(_ref15) {
        var color = _ref15.color;
        return color.text.black.base;
      },
      bg: function bg(_ref16) {
        var palette = _ref16.palette;
        return palette.neutralsBlack.rgba10;
      }
    },
    strokeDark: {
      text: function text(_ref17) {
        var color = _ref17.color;
        return color.text.black.base;
      },
      bg: function bg(_ref18) {
        var palette = _ref18.palette;
        return palette.transparent;
      },
      hasBorder: true
    },
    strokeLight: {
      text: function text(_ref19) {
        var color = _ref19.color;
        return color.text.white.base;
      },
      bg: function bg(_ref20) {
        var palette = _ref20.palette;
        return palette.transparent;
      },
      hasBorder: true
    }
  },
  iconSizes: {
    xs: 16,
    s: 18,
    m: 20,
    l: 24,
    xl: 30,
    xxl: 38,
    xxxl: 48
  },
  iconMarginX: "0.4em"
};